import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const ChaptersRepository = RepositoryFactory.get("chapters");

const actions = {
  get(context, theme) {
    return ChaptersRepository.get(theme);
  },
  getSubchapters(context, chapterId) {
    return ChaptersRepository.getSubchapters(chapterId);
  },
};

export default {
  namespaced: true,
  actions,
};
